import Konva from 'konva';

const isSingleDocumentAnnotationNode = (node: Konva.Node): boolean =>
  node.getAttr('containerId') !== undefined;

export default isSingleDocumentAnnotationNode;
